module.exports = __webpack_public_path__ + "img/rainslasher.8a135261.webp";